/**************************************************
 * Nombre:       Imagenes_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import botella from '../../../../Recursos/Temporales/botella.png'
import {useEffect, useState} from "react";

const Imagenes_Producto = ({item}) => {
    const [imgs, setImgs] = useState([]);

    useEffect(() => {



        let arr = []
        if (item && item.img){
            arr.push(item.img)
        }

        if (item &&  item.imgs){
            arr.push(...item.imgs)
        }

        setImgs(arr)

    },[item])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            {imgs.length > 0 &&
            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Splide
                    aria-label="My Favorite Images" style={{width: '100%'}}
                    options={{
                        autoplay: true,
                        speed: 1500,
                        rewind: true,
                        perPage: 1,
                        arrows: true,
                        pagination: true,
                        width: '100%',
                        drag: 'false',
                        interval: 8000,
                        noDrag: true,
                        type: 'loop',
                        gap: 20,
                        padding: 0


                    }}
                >

                    {imgs.map((it, index) => {
                        return (
                            <SplideSlide key={`qe${index}`}>
                                <img src={it} width={'100%'} height={'auto'}/>
                            </SplideSlide>
                        )
                    })}


                </Splide>
            </Grid>
            }

        </Grid>
    )

}
export default Imagenes_Producto

const items = [botella, botella, botella]